var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_3789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6013 24.599L18.5023 18.5L12.4033 24.599",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1.52475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5049 18.5V32.2228",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1.52475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2967 28.2434C32.7839 27.4327 33.9587 26.1498 34.6357 24.5972C35.3128 23.0446 35.4535 21.3107 35.0357 19.6693C34.6179 18.0278 33.6654 16.5722 32.3285 15.5323C30.9915 14.4923 29.3463 13.9271 27.6526 13.926H25.7314C25.2698 12.1409 24.4096 10.4836 23.2154 9.07882C22.0212 7.674 20.5241 6.55819 18.8366 5.81526C17.1491 5.07234 15.3151 4.72163 13.4725 4.78952C11.63 4.85741 9.82677 5.34212 8.19851 6.20721C6.57024 7.0723 5.15927 8.29526 4.07168 9.78415C2.98409 11.273 2.24818 12.9891 1.91928 14.8034C1.59037 16.6176 1.67703 18.4828 2.17274 20.2587C2.66845 22.0346 3.56031 23.6751 4.78127 25.0567",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1.52475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6013 24.599L18.5023 18.5L12.4033 24.599",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1.52475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_3789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.5941,
    height: 36.5941,
    fill: "white",
    transform: "translate(0.208008 0.203125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormFileUploadIcon);
export default __webpack_public_path__ + "static/media/formFileUploadIcon.63e053f83e8326276085f1143c339edb.svg";
export { ForwardRef as ReactComponent };